import { createProjectionNode } from './create-projection-node.mjs';
import { DocumentProjectionNode } from './DocumentProjectionNode.mjs';
var rootProjectionNode = {
  current: undefined
};
var HTMLProjectionNode = createProjectionNode({
  measureScroll: function measureScroll(instance) {
    return {
      x: instance.scrollLeft,
      y: instance.scrollTop
    };
  },
  defaultParent: function defaultParent() {
    if (!rootProjectionNode.current) {
      var documentNode = new DocumentProjectionNode({});
      documentNode.mount(window);
      documentNode.setOptions({
        layoutScroll: true
      });
      rootProjectionNode.current = documentNode;
    }
    return rootProjectionNode.current;
  },
  resetTransform: function resetTransform(instance, value) {
    instance.style.transform = value !== undefined ? value : "none";
  },
  checkIsScrollRoot: function checkIsScrollRoot(instance) {
    return Boolean(window.getComputedStyle(instance).position === "fixed");
  }
});
export { HTMLProjectionNode, rootProjectionNode };